module.exports = __webpack_public_path__ + "img/nodata.40b3992c.png";